export default {
      id: "clock-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }